import { render, staticRenderFns } from "./contentFeedbackAudit.vue?vue&type=template&id=d15611d4&scoped=true"
import script from "./contentFeedbackAudit.vue?vue&type=script&lang=js"
export * from "./contentFeedbackAudit.vue?vue&type=script&lang=js"
import style0 from "./contentFeedbackAudit.vue?vue&type=style&index=0&id=d15611d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15611d4",
  null
  
)

export default component.exports